import session from '@/shared/session'

// initial state
const state = {
	current : {},
}

// getters
const getters = {}

// actions
const actions = {
	cooldownOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/cooldowns/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	cooldownDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/cooldowns/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	cooldownCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/cooldowns/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	cooldownUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/cooldowns/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	cooldownRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/cooldowns/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterCooldown ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/cooldowns/get_filtered_cooldowns/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    cooldownStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/cooldowns/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
	activeCooldowns({ commit }) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/cooldowns/get_active_cooldowns/', {
				headers: {
					"Authorization": "Token " + localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data;
				resolve(data);
			})
			.catch(errors => {
				resolve(errors.response.data);
			});
		});
	},	
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
